module.exports = __webpack_public_path__ + "img/vcf.3019530a.svg";